/** @format */

export const checkIfObjectHasAnyData = (obj = null) => {
  if (obj && typeof obj === 'object' && Object.keys(obj).length > 0) {
    return true;
  }
  return false;
};
